import { IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonNote, IonPage, IonPopover, IonRow, IonSelect, IonSelectOption, IonTitle, IonToast, IonToggle, IonToolbar, isPlatform, useIonAlert, useIonViewDidEnter } from '@ionic/react';
import { add, arrowBack, checkmarkCircle, closeOutline, ellipsisVertical, eyeOutline, imageOutline, informationCircle, pauseCircle, pencilOutline, trashOutline } from 'ionicons/icons';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { assinaUrl, getCampanhaPrevia, postCampanha, putCampanha, requestService, urlBaseCore } from '../../../../../Utils/Services';
import "./ProgramarMensagensClientes.css";
import OfficialCampaignEditor, { OfficialTemplate, CampaignContext, campaignPresentation } from './OfficialCampaignEditor';

const modelosMensagemCampanha = [
  {
    id: "saudade_cliente",
    titulo: "Saudade do cliente",
    descricao: "Para clientes que não compram há alguns dias.",
    mensagem:
      "{Oi|Olá|E aí} @[nome-cliente]!\n{Sentimos sua falta|Faz tempo que você não pede com a gente|Que saudade de te ver por aqui} 😋\n{Que tal fazer um pedido hoje?|Bora matar a vontade hoje?|Seu próximo pedido está a poucos cliques.}\nPeça pelo link:\n@[link-pedido]"
  },
  {
    id: "promocao_dia",
    titulo: "Promoção do dia",
    descricao: "Para divulgar uma oferta simples.",
    mensagem:
      "{Oi|Olá} @[nome-cliente]!\n{Tem promoção especial hoje|Hoje tem oferta especial para você|Preparamos uma condição especial para hoje} 🔥\n{Aproveite e faça seu pedido|Peça agora e garanta o seu|Corre para aproveitar}:\n@[link-pedido]"
  },
  {
    id: "cupom_desconto",
    titulo: "Cupom de desconto",
    descricao: "Ideal quando a campanha possui cupom.",
    mensagem:
      "{Oi|Olá} @[nome-cliente]!\n{Tem cupom especial para você|Preparamos um desconto para o seu próximo pedido|Seu próximo pedido pode sair com desconto} 🎁\nUse o cupom @[cupom] e peça pelo link:\n@[link-pedido]"
  },
  {
    id: "hora_fome",
    titulo: "Hora da fome",
    descricao: "Mensagem descontraída para restaurantes, pizzarias e lanches.",
    mensagem:
      "{Oi|Olá|E aí} @[nome-cliente]!\n{Bateu a fome?|Hora de matar a vontade?|Que tal pedir algo gostoso agora?} 😋\n{Faça seu pedido pelo link|Peça rapidinho por aqui|Seu pedido está a poucos cliques}:\n@[link-pedido]"
  },
  {
    id: "novidade_cardapio",
    titulo: "Novidade no cardápio",
    descricao: "Para avisar sobre novos produtos.",
    mensagem:
      "{Oi|Olá} @[nome-cliente]!\n{Tem novidade no nosso cardápio|Chegaram novidades por aqui|Preparamos novidades para você experimentar} ✨\n{Confira e faça seu pedido|Veja as opções e escolha a sua|Dá uma olhada no cardápio}:\n@[link-pedido]"
  },
  {
    id: "pedido_rapido",
    titulo: "Pedido rápido",
    descricao: "Mensagem curta e direta.",
    mensagem:
      "{Oi|Olá} @[nome-cliente]!\n{Seu pedido está a poucos cliques|Peça de forma rápida pelo nosso link|Faça seu pedido online rapidinho}.\n@[link-pedido]"
  }
];

const ProgramarMensagensClientes: React.FC = () => {
  const history = useHistory<any>();
  const [showLoading, setShowLoading] = useState(false);
  const [listaCampanhas, setListaCampanhas] = useState<any>([]);

  const [showDetalhes, setShowDetalhes] = useState(false);
  const contentRef = useRef<HTMLIonContentElement | null>(null);
  const [index, setIndex] = useState("");

  // Estados da campanha
  const [nomeCampanha, setNomeCampanha] = useState("");
  const [statusCampanha, setStatusCampanha] = useState("ativo");
  const [quantidadeMensagensDia, setQuantidadeMensagensDia] = useState("100");
  const [publicoAlvo, setPublicoAlvo] = useState("comprou_ha");
  const [periodoPublicoAlvo, setPeriodoPublicoAlvo] = useState("7");
  const [diasSemana, setDiasSemana] = useState<string[]>([]);
  const [horarioInicio, setHorarioInicio] = useState("");
  const [anexarCupom, setAnexarCupom] = useState(false);
  const [cupomCampanha, setCupomCampanha] = useState("");
  const [mensagemEnviar, setMensagemEnviar] = useState("");
  const [modeloMensagemSelecionado, setModeloMensagemSelecionado] = useState<string>("");
  const [officialTemplate, setOfficialTemplate] = useState<OfficialTemplate>(null);
  const [campaignContext, setCampaignContext] = useState<CampaignContext | null>(null);
  const [etapaAtual, setEtapaAtual] = useState(1);
  const [fileArquivos, setFileArquivos] = useState<any>(null);
  const [fileDataURL, setFileDataURL] = useState<string | null>(null);
  const [urlImagem, setUrlImagem] = useState("");
  const [nomeImagem, setNomeImagem] = useState("");
  const [tipoImagem, setTipoImagem] = useState("");
  const presentation = campaignPresentation(campaignContext, officialTemplate, !!(fileArquivos || urlImagem), anexarCupom ? cupomCampanha : '');
  const removeCampaignImage = () => {
    setFileArquivos(null); setFileDataURL(null); setUrlImagem(''); setNomeImagem(''); setTipoImagem('');
    if (imagemInputRef.current) imagemInputRef.current.value = '';
  };

  const [showToast, setShowToast] = useState(false);
  const [textToast, setTextToast] = useState("");

  const { loja, setLoja } = useContext(MessageContext);
  const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
  const isWeb = isPlatform('desktop');
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
  const { nomeMenu, setNomeMenu } = useContext(MessageContext);
  const { dadosEmpresa, setDadosEmpresa } = useContext(MessageContext);

  const [mostartAlerta] = useIonAlert();
  const inputRef = useRef<any>(null);
  const imagemInputRef = useRef<HTMLInputElement | null>(null);

  // Popover de ações
  const [showPopoverGrid, setShowPopoverGrid] = useState(false);
  const [popoverEventGrid, setPopoverEventGrid] = useState<any>(null);
  const [itemSelecionado, setItemSelecionado] = useState<any>(null);

  // Modal de prévia
  const [showModalPrevia, setShowModalPrevia] = useState(false);
  const [previaDados, setPreviaDados] = useState<any>(null);

  // Inicializa a mensagem padrão
  useEffect(() => {
    if (mensagemEnviar === "") {
      const mensagemPadrao = "{Oi|Olá|E aí} @[nome-cliente]!\n{Bateu a fome?|Hora de matar a vontade?|Que tal agora?} 😋\nPeça já pelo link:\n@[link-pedido]";
      setMensagemEnviar(mensagemPadrao);
    }
  }, []);

  // Função para montar a mensagem dinamicamente
  useEffect(() => {
    if (index === "") {
      // Nova campanha - monta mensagem padrão
      let mensagemBase = "{Oi|Olá|E aí} @[nome-cliente]!\n{Bateu a fome?|Hora de matar a vontade?|Que tal agora?} 😋";

      if (anexarCupom && cupomCampanha) {
        mensagemBase += `\nUse o cupom ${cupomCampanha} e aproveite!`;
      }

      mensagemBase += "\nPeça já pelo link:\n@[link-pedido]";
      setMensagemEnviar(mensagemBase);
    } else if (index !== "") {
      // Editando campanha - atualiza apenas a parte do cupom
      setMensagemEnviar(prev => {
        let mensagemAtual = prev;

        // Remove linha de cupom existente
        mensagemAtual = mensagemAtual.replace(/\nUse o cupom .+ e aproveite!/g, '');

        if (anexarCupom && cupomCampanha) {
          // Adiciona nova linha de cupom antes do link
          mensagemAtual = mensagemAtual.replace(
            /\nPeça já pelo link:/g,
            `\nUse o cupom ${cupomCampanha} e aproveite!\nPeça já pelo link:`
          );
        }

        return mensagemAtual;
      });
    }
  }, [anexarCupom, cupomCampanha, index]);

  const opcoesPublicoAlvo = [
    { value: "comprou_ha", label: "Comprou" },
    { value: "comprou_1_vez", label: "Comprou 1 vez" },
    { value: "nao_comprou_ha", label: "Não comprou" },
    { value: "clientes_vip", label: "Clientes VIP" }
  ];

  const opcoesPeriodo = [
    { value: "7", label: "7 dias" },
    { value: "15", label: "15 dias" },
    { value: "30", label: "30 dias" }
  ];

  const diasDaSemana = [
    { value: "SEG", label: "S", nome: "Segunda" },
    { value: "TER", label: "T", nome: "Terça" },
    { value: "QUA", label: "Q", nome: "Quarta" },
    { value: "QUI", label: "Q", nome: "Quinta" },
    { value: "SEX", label: "S", nome: "Sexta" },
    { value: "SAB", label: "S", nome: "Sábado" },
    { value: "DOM", label: "D", nome: "Domingo" }
  ];

  const getDescricaoPublico = (camp: any) => {
    const periodoStr = `${camp.periodo} dias`;
    switch (camp.publicoAlvo) {
      case 'comprou_ha':
        return `Comprou`;
      case 'comprou_1_vez':
        return `Comprou 1 vez`;
      case 'nao_comprou_ha':
        return `Não comprou`;
      case 'clientes_vip':
        return 'Clientes VIP';
      default:
        return '';
    }
  };

  function getButtonsGridCampanha(value: any) {
    const resultado: any[] = [];


    if (acessos?.configuracoes == 'edicao') {
      resultado.push({
        text: 'Editar',
        disabled: false,
        icon: pencilOutline,
        handler: () => editarCampanha(value.indice)
      });
    }

    // Prévia (leitura ou edição)
    if (acessos?.configuracoes == 'leitura' || acessos?.configuracoes == 'edicao') {
      resultado.push({
        text: 'Prévia',
        disabled: false,
        icon: eyeOutline,
        handler: () => previaCampanha(value.indice)
      });
    }

    // Editar (somente edição)
    if (acessos?.configuracoes == 'edicao') {

      // Excluir
      resultado.push({
        text: 'Excluir',
        disabled: false,
        icon: trashOutline,
        handler: () => deletarCampanha(value.indice)
      });
    }

    // Cancelar
    resultado.push({
      text: 'Cancelar',
      disabled: false,
      icon: closeOutline,
      role: 'cancel',
      handler: () => { }
    });

    return resultado;
  }

  useIonViewDidEnter(() => {
    setEsconderMenu(true);
    setNomeMenu("");
    carregarCampanhas();
  });

  const carregarCampanhas = async () => {
    try {
      setShowLoading(true);

      const url = `${urlBaseCore.url}/campanhas/empresa/${loja.replaceAll(/#/g, '%23')}`;

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: urlBaseCore.method,
            timeout: 15000,
          },
          history,
          (response) => {
            if (response.Items) {
              setListaCampanhas(response.Items);
            } else {
              setListaCampanhas([]);
            }
            resolve();
          },
          (error) => {
            console.error("Erro ao carregar campanhas:", error);

            // Se for erro 404, significa que não há campanhas ainda
            if (error.status === 404) {
              setListaCampanhas([]);
              resolve();
            } else {
              reject(new Error(error.message || "Erro ao carregar campanhas"));
            }
          }
        );
      });

    } catch (error: any) {
      console.error("Erro ao carregar campanhas:", error);
      setTextToast("Erro ao carregar campanhas.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  }

  const deletarCampanha = async (indice: number) => {
    mostartAlerta({
      backdropDismiss: false,
      header: 'Remover campanhas',
      message: 'Deseja <strong>remover</strong> esta campanha?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
        },
        {
          text: 'Confirmar',
          cssClass: 'primary',
          handler: async () => {
            try {
              setShowLoading(true);

              const campanha = listaCampanhas[indice];
              const url = `${urlBaseCore.url}/campanhas/${String(campanha.id).replaceAll(/#/g, '%23')}`;

              await new Promise<void>((resolve, reject) => {
                requestService(
                  url,
                  {
                    method: 'DELETE',
                    body: JSON.stringify({ empresaid: loja }),
                    timeout: 15000,
                  },
                  history,
                  (response) => {
                    // Remover da lista local
                    const novasCampanhas = listaCampanhas.filter((_: any, i: number) => i !== indice);
                    setListaCampanhas(novasCampanhas);
                    setTextToast("Campanha removida com sucesso.");
                    setShowToast(true);
                    resolve();
                  },
                  (error) => {
                    console.error("Erro ao deletar campanha:", error);
                    setTextToast(error.message || "Erro ao deletar campanha.");
                    setShowToast(true);
                    reject(new Error(error.message || "Erro ao deletar campanha"));
                  }
                );
              });

            } catch (error: any) {
              console.error("Erro ao deletar campanha:", error);
              // Erro já tratado no callback, não precisa fazer nada mais
            } finally {
              setShowLoading(false);
            }
          }
        }
      ],
    });
  }

  const previaCampanha = async (indice: number) => {
    try {
      setShowLoading(true);

      const campanha = listaCampanhas[indice];
      const campanhaIdEncoded = String(campanha.id).replaceAll(/#/g, '%23');
      const url = getCampanhaPrevia.url.replace('{campanhaid}', campanhaIdEncoded);

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: getCampanhaPrevia.method,
            timeout: 20000,
          },
          history,
          (response) => {
            setPreviaDados(response);
            setShowModalPrevia(true);
            resolve();
          },
          (error) => {
            console.error('Erro ao carregar prévia da campanha:', error);
            setTextToast(error.message || 'Erro ao carregar prévia da campanha.');
            setShowToast(true);
            reject(new Error(error.message || 'Erro ao carregar prévia da campanha.'));
          }
        );
      });

    } catch (error: any) {
      console.error('Erro ao obter prévia da campanha:', error);
    } finally {
      setShowLoading(false);
    }
  }

  const assinaUploadS3ArquivoESalvar = async (file: any) => {
    try {
      let fileParts = file && file.name ? file.name.split('.') : [];
      let fileNameArquivo = fileParts[0] || '';
      let fileTypeArquivo = fileParts[1] || '';

      let params = {
        nome: fileNameArquivo,
        tipo: fileTypeArquivo
      }

      if (file && file.name) {
        // Assina URL
        const resp = await fetch(assinaUrl.url.concat("?pasta=campanhas-mensagens&bucket=xeguei-mobile-publico"), {
          method: assinaUrl.method,
          headers: [
            ["token", localStorage.getItem("token") || ""]
          ],
          body: JSON.stringify(params),
          credentials: 'include'
        });

        const response = await resp.json();

        if (response.Item) {
          const uploadToS3 = await fetch(response.Item.urlAssinado, {
            method: "PUT",
            headers: {
              "Content-Type": "image/" + fileTypeArquivo,
            },
            body: file,
          });

          if (uploadToS3.status === 200) {
            // Retorna os valores diretamente ao invés de usar setState
            return {
              urlImagem: response.Item.urlPublica,
              nomeImagem: response.Item.fileName,
              tipoImagem: fileTypeArquivo
            };
          } else {
            throw new Error('Erro ao fazer upload do arquivo.');
          }
        } else {
          throw new Error('Erro ao assinar a URL.');
        }
      }

      return null;
    } catch (error) {
      console.error("Erro no upload:", error);
      throw error; // Re-throw para que salvarCampanha possa tratar o erro
    }
  }

  const toggleDiaSemana = (diaClicado: string) => {
    if (diasSemana.includes(diaClicado)) {
      // Remove o dia específico
      setDiasSemana(diasSemana.filter(d => d !== diaClicado));
    } else {
      // Adiciona o dia específico
      setDiasSemana([...diasSemana, diaClicado]);
    }
  };

  const possuiVariacaoAutomatica = (mensagem: string) => {
    const matches = (mensagem || "").match(/\{([^{}]+)\}/g);

    if (!matches) return false;

    return matches.some((match) => {
      const conteudo = match.slice(1, -1);
      const opcoes = conteudo
        .split("|")
        .map((opcao) => opcao.trim())
        .filter(Boolean);

      return opcoes.length >= 2;
    });
  };

  const gerarPreviaMensagem = (mensagem: string, indiceVariacao: number = 0) => {
    return (mensagem || "")
      .replace(/\{([^}]+)\}/g, (match, options) => {
        if (!options.includes("|")) return match;

        const opcoes = options
          .split("|")
          .map((opcao: string) => opcao.trim())
          .filter(Boolean);

        return opcoes[indiceVariacao % opcoes.length] || "";
      })
      .replace(/@\[nome-cliente\]/g, "João")
      .replace(/@\[link-pedido\]/g, "https://seudominio.xeguei.com.br")
      .replace(/@\[cupom\]/g, "PROMO10");
  };

  const gerarPreviasMensagem = (mensagem: string) => {
    if (!mensagem.trim()) return [];

    return [0, 1, 2].map((indice) => gerarPreviaMensagem(mensagem, indice));
  };

  const aplicarModeloMensagem = (modelo: any) => {
    let mensagem = modelo.mensagem;

    if (cupomCampanha) {
      mensagem = mensagem.replace(/@\[cupom\]/g, cupomCampanha);
    }

    setModeloMensagemSelecionado(modelo.id);
    setMensagemEnviar(mensagem);
  };

  const inserirVariavelMensagem = (variavel: string) => {
    setMensagemEnviar((prev) => {
      const mensagemAtual = prev || "";

      if (!mensagemAtual.trim()) return variavel;

      return `${mensagemAtual}${mensagemAtual.endsWith("\n") ? "" : " "}${variavel}`;
    });
  };

  const salvarCampanha = async (paused = false) => {
    const nextStatus = paused ? 'pausado' : statusCampanha;
    if (!campaignContext) {
      setTextToast('Consulte o formato de envio antes de salvar.'); setShowToast(true); return;
    }
    if (nextStatus === 'ativo' && presentation.activationError) {
      setTextToast(presentation.activationError); setShowToast(true); return;
    }
    if (nextStatus === 'ativo' && presentation.configurationError && officialTemplate) {
      setTextToast(presentation.configurationError); setShowToast(true); return;
    }
    // Validações locais
    if (!nomeCampanha.trim()) {
      setTextToast("Nome da campanha é obrigatório.");
      setShowToast(true);
      return;
    }

    if (diasSemana.length === 0) {
      setTextToast("Selecione pelo menos um dia da semana.");
      setShowToast(true);
      return;
    }

    if (!horarioInicio) {
      setTextToast("Defina o horário de envio.");
      setShowToast(true);
      return;
    }

    if (presentation.freeTextMode && !mensagemEnviar.trim()) {
      setTextToast("Mensagem a enviar é obrigatória.");
      setShowToast(true);
      return;
    }

    if (presentation.freeTextMode && !possuiVariacaoAutomatica(mensagemEnviar)) {
      setTextToast("Escolha um modelo de mensagem ou adicione pelo menos uma variação no texto.");
      setShowToast(true);
      return;
    }

    try {
      setShowLoading(true);

      // Upload da imagem se houver arquivo selecionado
      let dadosImagem = null;
      if (fileArquivos) {
        try {
          dadosImagem = await assinaUploadS3ArquivoESalvar(fileArquivos);
          // Atualiza os estados após upload bem-sucedido
          if (dadosImagem) {
            setUrlImagem(dadosImagem.urlImagem);
            setNomeImagem(dadosImagem.nomeImagem);
            setTipoImagem(dadosImagem.tipoImagem);
          }
        } catch (uploadError) {
          setTextToast("Erro ao fazer upload da imagem.");
          setShowToast(true);
          return;
        }
      }

      const novaCampanha: any = {
        nome: nomeCampanha,
        status: nextStatus,
        quantidadeMensagensDia: parseInt(quantidadeMensagensDia) || 100,
        publicoAlvo,
        periodo: parseInt(periodoPublicoAlvo) || 7,
        diasSemana: diasSemana.sort((a: string, b: string) => {
          const indexA = diasDaSemana.findIndex(d => d.value === a);
          const indexB = diasDaSemana.findIndex(d => d.value === b);
          return indexA - indexB;
        }),
        horarioInicio,
        cupom: anexarCupom ? cupomCampanha : "",
        mensagem: mensagemEnviar,
        officialTemplate,
        empresaid: loja,
        // Explicit empty values also clear a previously saved image on edit.
        urlImagem: '', nomeImagem: '', tipoImagem: ''
      };

      // Adiciona campos de imagem se houver dados de upload ou imagem existente
      if (dadosImagem) {
        // Nova imagem enviada
        novaCampanha.urlImagem = dadosImagem.urlImagem;
        novaCampanha.nomeImagem = dadosImagem.nomeImagem;
        novaCampanha.tipoImagem = dadosImagem.tipoImagem;
      } else if (urlImagem && nomeImagem && tipoImagem) {
        // Imagem existente (edição)
        novaCampanha.urlImagem = urlImagem;
        novaCampanha.nomeImagem = nomeImagem;
        novaCampanha.tipoImagem = tipoImagem;
      }

      // Inclui domínio apenas se estiver definido
      if (dadosEmpresa?.dominio) {
        novaCampanha.dominio = dadosEmpresa.dominio;
      }

      const isEdicao = index !== "";
      const url = isEdicao
        ? putCampanha.url.replace("{id}", listaCampanhas[parseInt(index)].id)
        : postCampanha.url;

      await new Promise<void>((resolve, reject) => {
        requestService(
          url,
          {
            method: isEdicao ? putCampanha.method : postCampanha.method,
            body: JSON.stringify(novaCampanha),
            timeout: 30000,
          },
          history,
          (response) => {
            if (response.message || response.id) {
              // Atualizar lista local
              if (isEdicao) {
                const campanhas = [...listaCampanhas];
                campanhas[parseInt(index)] = {
                  ...novaCampanha,
                  id: campanhas[parseInt(index)].id
                };
                setListaCampanhas(campanhas);
                setTextToast(nextStatus === 'pausado' ? "Configuração salva. A campanha está pausada." : "Campanha atualizada com sucesso.");
              } else {
                const novaCampanhaComId = {
                  ...novaCampanha,
                  id: response?.Item?.id
                };
                setListaCampanhas([...listaCampanhas, novaCampanhaComId]);
                setTextToast(nextStatus === 'pausado' ? "Configuração salva. A campanha está pausada." : "Campanha criada com sucesso.");
              }
              resolve();
            } else {
              reject(new Error("Resposta inválida do servidor"));
            }
          },
          (error) => {
            console.error("Erro ao salvar campanha:", error);
            reject(new Error(error.message || "Erro ao salvar campanha"));
          }
        );
      });

      setShowToast(true);
      fecharModal();

    } catch (error: any) {
      console.error("Erro ao salvar campanha:", error);
      setTextToast(error.message || "Erro ao salvar campanha.");
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }
  }

  function fecharModal() {
    setShowDetalhes(false);
    limparFormulario();
  }

  function limparFormulario() {
    setIndex("");
    setNomeCampanha("");
    setStatusCampanha("ativo");
    setQuantidadeMensagensDia("100");
    setPublicoAlvo("comprou_ha");
    setPeriodoPublicoAlvo("7");
    setDiasSemana([]);
    setHorarioInicio("");
    setAnexarCupom(false);
    setCupomCampanha("");
    setFileArquivos(null);
    setFileDataURL(null);
    setUrlImagem("");
    setNomeImagem("");
    setTipoImagem("");
    const mensagemPadrao = "{Oi|Olá|E aí} @[nome-cliente]!\n{Bateu a fome?|Hora de matar a vontade?|Que tal agora?} 😋\nPeça já pelo link:\n@[link-pedido]";
    setMensagemEnviar(mensagemPadrao);
    setModeloMensagemSelecionado("");
    setOfficialTemplate(null);
    setCampaignContext(null);
    setEtapaAtual(1);
  }

  function editarCampanha(indice: number) {
    const campanha = listaCampanhas[indice];
    setIndex(indice.toString());
    setNomeCampanha(campanha.nome);
    setStatusCampanha(campanha.status || 'ativo');
    setQuantidadeMensagensDia(campanha.quantidadeMensagensDia?.toString() || '100');
    setPublicoAlvo(campanha.publicoAlvo);
    setPeriodoPublicoAlvo(campanha.periodo?.toString() || "7");
    setDiasSemana(campanha.diasSemana);
    setHorarioInicio(campanha.horarioInicio);
    setAnexarCupom(!!campanha.cupom);
    setCupomCampanha(campanha.cupom || "");
    setMensagemEnviar(campanha.mensagem);
    setOfficialTemplate(campanha.officialTemplate || null);
    setCampaignContext(null);
    setModeloMensagemSelecionado("");
    setFileArquivos(null);
    setFileDataURL(campanha.urlImagem || null);
    setUrlImagem(campanha.urlImagem || "");
    setNomeImagem(campanha.nomeImagem || "");
    setTipoImagem(campanha.tipoImagem || "");
    setEtapaAtual(1);
    setShowDetalhes(true);
  }

  function avancarEtapa() {
    if (etapaAtual === 1 && !nomeCampanha.trim()) {
      setTextToast("Nome da campanha é obrigatório.");
      setShowToast(true);
      return;
    }
    if (etapaAtual < 5) {
      setEtapaAtual(etapaAtual + 1);
    }
  }

  function voltarEtapa() {
    if (etapaAtual > 1) {
      setEtapaAtual(etapaAtual - 1);
    }
  }

  const loadCampanhas = () => {
    if (!listaCampanhas || listaCampanhas.length === 0) {
      return (
        <IonItem lines="full" key={"semCampanhas"}>
          <IonLabel>
            <h2 style={{ verticalAlign: "middle" }}><strong>Nenhuma campanha cadastrada</strong></h2>
          </IonLabel>
        </IonItem>
      );
    }

    return (
      <>
        {listaCampanhas.map((campanha: any, index: any) => (
          <IonItem lines="full" key={index}>
            <IonLabel style={{ fontSize: "12px", width: "30px", minWidth: "30px", maxWidth: "30px" }}>
              <IonIcon
                icon={campanha.status === 'ativo' ? checkmarkCircle : pauseCircle}
                color={campanha.status === 'ativo' ? 'success' : 'warning'}
                style={{ fontSize: '20px' }}
              />
            </IonLabel>
            <IonLabel style={{ fontSize: "12px", flex: 1, minWidth: "100px" }}>
              <div style={{ fontWeight: 'bold' }}>{campanha.nome}</div>
              <div style={{ fontSize: '10px', color: '#666' }}>{getDescricaoPublico(campanha)}</div>
            </IonLabel>
            <IonLabel style={{ fontSize: "12px", textAlign: "center", width: "100px", minWidth: "100px", maxWidth: "100px" }}>
              <div style={{ fontWeight: 'bold' }}>{campanha.quantidadeMensagensDia || 100}</div>
              <div style={{ fontSize: '10px', color: '#666' }}>msgs/dia</div>
            </IonLabel>
            <IonLabel style={{ fontSize: "10px", flex: 1, paddingRight: "80px" }}>
              {campanha.diasSemana
                .sort((a: string, b: string) => {
                  const indexA = diasDaSemana.findIndex(d => d.value === a);
                  const indexB = diasDaSemana.findIndex(d => d.value === b);
                  return indexA - indexB;
                })
                .map((dia: string) => {
                  const diaInfo = diasDaSemana.find(d => d.value === dia);
                  return diaInfo ? diaInfo.label : dia;
                }).join(', ')} às {campanha.horarioInicio}
            </IonLabel>

            <div style={{ position: "absolute", right: "10px", zIndex: 9999999, backgroundColor: "#ffffff" }}>
              <IonButtons>
                <IonButton
                  fill="clear"
                  onClick={(e: any) => { setItemSelecionado({ ...campanha, indice: index }); setPopoverEventGrid(e); setShowPopoverGrid(true); }}
                >
                  <IonIcon color="primary" icon={ellipsisVertical} />
                </IonButton>
              </IonButtons>
            </div>
          </IonItem>
        ))}
      </>
    );
  };

  return (
    <IonPage className="ProgramarMensagensClientes">
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack(); }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Programar</IonTitle>
        </IonToolbar>

        <IonToolbar hidden={acessos?.campanhas != 'edicao'}>
          {isWeb && (
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "8px 8px 0 8px" }}>
              <IonButton
                fill="solid"
                size="large"
                color="tertiary"
                onClick={() => {
                  limparFormulario();
                  setShowDetalhes(true);
                }}>
                <IonIcon slot="start" icon={add} />
                Nova campanha
              </IonButton>
            </div>
          )}
        </IonToolbar>

        <IonToolbar>
          <IonList>
            <IonItem lines="none" style={{ fontWeight: 'bold', borderBottom: '1px solid #dddddd' }}>
              <IonLabel style={{ fontSize: "12px", width: "30px", minWidth: "30px", maxWidth: "30px" }}></IonLabel>
              <IonLabel style={{ fontSize: "12px", flex: 1, minWidth: "100px" }}>Nome</IonLabel>
              <IonLabel style={{ fontSize: "12px", textAlign: "center", width: "100px", minWidth: "100px", maxWidth: "100px" }}>Limite diário</IonLabel>
              <IonLabel style={{ fontSize: "12px", flex: 1, paddingRight: "80px" }}>Horários</IonLabel>
            </IonItem>
          </IonList>
        </IonToolbar>

      </IonHeader>

      <IonContent fullscreen={false}>
        {!isWeb && (
          <IonFab vertical="bottom" horizontal="center" slot="fixed" hidden={acessos?.campanhas !== 'edicao'}>
            <IonFabButton color="tertiary" class="custom-fab-button" onClick={() => {
              limparFormulario();
              setShowDetalhes(true);
            }}>
              <IonIcon color="light" icon={add}></IonIcon>
            </IonFabButton>
          </IonFab>
        )}

        <IonList>
          {loadCampanhas()}
        </IonList>

        {/* Modal para criar/editar campanha */}
        <IonModal
          // className="fullscreen-modal" 
          isOpen={showDetalhes}
          onDidDismiss={fecharModal}
          onDidPresent={() => {
            if (inputRef.current) {
              inputRef.current.setFocus();
            }
          }}
        >
          <IonHeader className="ion-no-border">
            <IonToolbar>
              <IonButtons slot="start">
                <IonIcon slot="icon-only" icon={arrowBack} onClick={fecharModal} />
              </IonButtons>
              <IonTitle>{index === "" ? "Nova campanha" : "Editar campanha"}</IonTitle>
            </IonToolbar>
          </IonHeader>

          <IonContent>
            <IonGrid>
              {/* Indicadores de etapa */}
              <IonRow className="ion-justify-content-center" style={{ marginBottom: '20px' }}>
                <IonCol size="auto">
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {[1, 2, 3, 4, 5].map((num) => (
                      <div key={num} style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                          width: '30px',
                          height: '30px',
                          borderRadius: '50%',
                          backgroundColor: etapaAtual >= num ? 'var(--ion-color-primary)' : '#e0e0e0',
                          color: etapaAtual >= num ? 'white' : '#666',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontWeight: 'bold'
                        }}>
                          {etapaAtual > num ? '✓' : num}
                        </div>
                        {num < 5 && <div style={{ width: '15px', height: '2px', backgroundColor: etapaAtual > num ? 'var(--ion-color-primary)' : '#e0e0e0', margin: '0 2px' }} />}
                      </div>
                    ))}
                  </div>
                </IonCol>
              </IonRow>

              {/* Etapa 1: Nome da campanha */}
              {etapaAtual === 1 && (
                <IonCard>
                  <IonCardContent>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: 'var(--ion-color-primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '10px', fontWeight: 'bold' }}>1</div>
                      <h2 style={{ margin: 0, fontWeight: 'bold' }}>Nome da campanha</h2>
                    </div>

                    <IonInput
                      ref={inputRef}
                      placeholder="Digite o nome da campanha"
                      value={nomeCampanha}
                      onIonInput={(e: any) => setNomeCampanha(e.target.value)}
                      style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '10px' }}
                    />

                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                      <h3 style={{ margin: 0, marginRight: '15px', fontSize: '16px' }}>Status da campanha:</h3>
                      <IonToggle
                        checked={statusCampanha === 'ativo'}
                        onIonChange={(e) => setStatusCampanha(e.detail.checked ? 'ativo' : 'pausado')}
                      />
                      <span style={{ marginLeft: '10px', fontSize: '14px', color: statusCampanha === 'ativo' ? 'var(--ion-color-success)' : 'var(--ion-color-warning)' }}>
                        {statusCampanha === 'ativo' ? 'Ativo' : 'Pausado'}
                      </span>
                    </div>

                    <div style={{ marginTop: '20px' }}>
                      <h3 style={{ margin: 0, marginBottom: '10px', fontSize: '16px' }}>Quantidade de mensagens por dia:</h3>
                      <IonInput
                        type="number"
                        placeholder="Digite a quantidade"
                        value={quantidadeMensagensDia}
                        onIonInput={(e: any) => setQuantidadeMensagensDia(e.target.value)}
                        min="1"
                        max="1000"
                        style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '10px' }}
                      />
                      <div style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                        Limite máximo de mensagens que serão enviadas por dia nessa campanha
                      </div>
                    </div>

                  </IonCardContent>
                </IonCard>
              )}

              {/* Etapa 2: Público alvo */}
              {etapaAtual === 2 && (
                <IonCard>
                  <IonCardContent>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: 'var(--ion-color-primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '10px', fontWeight: 'bold' }}>2</div>
                      <h2 style={{ margin: 0, fontWeight: 'bold' }}>Público alvo</h2>
                    </div>
                    <p style={{ color: '#666', marginBottom: '20px' }}>Selecione o tipo de filtragem para os cliente da campanha</p>

                    <div style={{ marginBottom: '20px' }}>
                      <div style={{
                        border: publicoAlvo === 'comprou_ha' ? '1px solid #e0e0e0' : '1px solid #e0e0e0',
                        borderRadius: '8px',
                        padding: '20px',
                        textAlign: 'center',
                        cursor: 'pointer'
                      }} onClick={() => setPublicoAlvo('comprou_ha')}>
                        <IonIcon icon={checkmarkCircle} style={{ fontSize: '40px', color: 'var(--ion-color-primary)' }} />
                        <div style={{ fontWeight: 'bold', marginTop: '10px' }}>Período</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>Filtro por frequência de compras</div>
                      </div>


                    </div>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <IonLabel>Quem</IonLabel>
                      <IonSelect
                        value={publicoAlvo}
                        onIonChange={(e) => setPublicoAlvo(e.detail.value)}
                        style={{ flex: 1 }}
                      >
                        {opcoesPublicoAlvo.map(opcao => (
                          <IonSelectOption key={opcao.value} value={opcao.value}>
                            {opcao.label}
                          </IonSelectOption>
                        ))}
                      </IonSelect>
                      <IonSelect
                        value={periodoPublicoAlvo}
                        onIonChange={(e) => setPeriodoPublicoAlvo(e.detail.value)}
                        style={{ flex: 1 }}
                      >
                        {opcoesPeriodo.map(opcao => (
                          <IonSelectOption key={opcao.value} value={opcao.value}>
                            {opcao.label}
                          </IonSelectOption>
                        ))}
                      </IonSelect>
                    </div>
                  </IonCardContent>
                </IonCard>
              )}

              {/* Etapa 3: Horários de envio */}
              {etapaAtual === 3 && (
                <IonCard>
                  <IonCardContent>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: 'var(--ion-color-primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '10px', fontWeight: 'bold' }}>3</div>
                      <h2 style={{ margin: 0, fontWeight: 'bold' }}>Horários de envio</h2>
                    </div>

                    <div style={{ backgroundColor: '#fff3cd', padding: '10px', borderRadius: '5px', marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
                      <IonIcon icon={informationCircle} color="warning" style={{ marginRight: '10px', fontSize: '18px', minWidth: '18px' }} />
                      <span style={{ fontSize: '12px' }}>As mensagens sempre serão enviadas de acordo com o horário de Brasília (GMT-3)</span>
                    </div>

                    <div style={{ display: 'flex', gap: '5px', marginBottom: '20px', justifyContent: 'center' }}>
                      {diasDaSemana.map((dia, index) => {
                        // Verifica se este dia específico está selecionado
                        const estaSelecionado = diasSemana.includes(dia.value);

                        return (
                          <IonButton
                            key={index}
                            fill={estaSelecionado ? "solid" : "outline"}
                            color={estaSelecionado ? "primary" : "medium"}
                            onClick={() => toggleDiaSemana(dia.value)}
                            style={{ width: '40px', height: '40px' }}
                          >
                            {dia.label}
                          </IonButton>
                        );
                      })}
                    </div>

                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <IonLabel>Horário de envio:</IonLabel>
                      <IonSelect
                        value={horarioInicio}
                        onIonChange={(e: any) => setHorarioInicio(e.detail.value)}
                        style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '10px', width: '100%' }}
                        placeholder="Selecione o horário"
                      >
                        <IonSelectOption value="09:00">09:00</IonSelectOption>
                        <IonSelectOption value="10:00">10:00</IonSelectOption>
                        <IonSelectOption value="11:00">11:00</IonSelectOption>
                        <IonSelectOption value="12:00">12:00</IonSelectOption>
                        <IonSelectOption value="13:00">13:00</IonSelectOption>
                        <IonSelectOption value="14:00">14:00</IonSelectOption>
                        <IonSelectOption value="15:00">15:00</IonSelectOption>
                        <IonSelectOption value="16:00">16:00</IonSelectOption>
                        <IonSelectOption value="17:00">17:00</IonSelectOption>
                        <IonSelectOption value="18:00">18:00</IonSelectOption>
                        <IonSelectOption value="19:00">19:00</IonSelectOption>
                        <IonSelectOption value="20:00">20:00</IonSelectOption>
                      </IonSelect>
                    </div>
                    {/* <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      <IonLabel>Horário de envio:</IonLabel>
                      <IonInput
                        type="time"
                        value={horarioInicio}
                        onIonInput={(e: any) => setHorarioInicio(e.target.value)}
                        style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '5px' }}
                      />
                    </div> */}
                  </IonCardContent>
                </IonCard>
              )}

              {/* Etapa 4: Cupom de desconto */}
              {etapaAtual === 4 && (
                <IonCard>
                  <IonCardContent>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: 'var(--ion-color-primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '10px', fontWeight: 'bold' }}>4</div>
                      <h2 style={{ margin: 0, fontWeight: 'bold' }}>Cupom de desconto (opcional)</h2>
                    </div>
                    <p style={{ color: '#666', marginBottom: '20px' }}>Defina se deseja vincular um cupom ao link da campanha</p>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
                      <IonToggle
                        checked={anexarCupom}
                        onIonChange={(e) => setAnexarCupom(e.detail.checked)}
                      />
                      <IonLabel>Anexar cupom ao link da campanha</IonLabel>

                    </div>
                    <div>

                      {anexarCupom && (() => {
                        // Cupons invisíveis (visivel === false) não devem ser sugeridos em campanhas automáticas.
                        const cuponsVisiveis = Array.isArray(dadosEmpresa?.configuracoesCupom)
                          ? dadosEmpresa.configuracoesCupom.filter((c: any) => c?.visivel !== false)
                          : [];
                        return (
                          <div style={{ flex: 1 }}>
                            {cuponsVisiveis.length > 0 ? (
                              <IonSelect
                                placeholder="Selecione um cupom"
                                value={cupomCampanha}
                                onIonChange={(e) => setCupomCampanha(e.detail.value)}
                                style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '10px', width: '100%' }}
                              >
                                {cuponsVisiveis.map((cupom: any, index: number) => (
                                  <IonSelectOption key={index} value={cupom.nome}>
                                    {cupom.nome}
                                  </IonSelectOption>
                                ))}
                              </IonSelect>
                            ) : (
                              <div style={{ padding: '10px', color: '#666', fontStyle: 'italic', fontSize: '12px' }}>
                                Nenhum cupom configurado
                              </div>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                  </IonCardContent>
                </IonCard>
              )}

              {/* Etapa 5: Mensagem a enviar */}
              {etapaAtual === 5 && (
                <IonCard>
                  <IonCardContent>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                      <div style={{ width: '30px', height: '30px', borderRadius: '50%', backgroundColor: 'var(--ion-color-primary)', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '10px', fontWeight: 'bold' }}>5</div>
                      <h2 style={{ margin: 0, fontWeight: 'bold' }}>Mensagem a enviar</h2>
                    </div>
                    <OfficialCampaignEditor empresaId={loja} value={officialTemplate} onChange={setOfficialTemplate}
                      onContext={setCampaignContext} hasImage={!!(fileArquivos || urlImagem)} coupon={anexarCupom ? cupomCampanha : ''}
                      business={dadosEmpresa?.empresaNome || dadosEmpresa?.nomeFantasia || dadosEmpresa?.nome || ''} onRemoveImage={removeCampaignImage} />
                    {presentation.freeTextMode && <p style={{ color: '#666', marginBottom: '20px' }}>
                      Crie a mensagem que será enviada aos seus clientes. Use variações para deixar cada mensagem mais natural e personalizada.
                    </p>}

                    {/* <div className="campanha-mensagem-ajuda">
                      <div className="campanha-mensagem-ajuda-titulo">
                        <IonIcon icon={informationCircle} color="primary" />
                        <strong>Variações automáticas</strong>
                      </div>
                      <p>
                        As mensagens prontas já possuem variações automáticas para deixar o envio mais natural.
                      </p>
                      <code>{'{Oi|Olá|E aí} @[nome-cliente]!'}</code>
                      <p>
                        Exemplo de variação: o sistema escolhe uma opção automaticamente para cada cliente.
                      </p>
                    </div> */}

                    {/* Campo de upload de imagem */}
                    {(presentation.freeTextMode || presentation.needsImage) && <div style={{ marginBottom: '20px' }}>
                      <h3 style={{ margin: 0, marginBottom: '10px', fontSize: '16px' }}>{presentation.needsImage ? 'Imagem do template (obrigatória)' : 'Imagem (opcional)'}</h3>
                      <input
                        ref={imagemInputRef}
                        type="file"
                        accept="image/*"
                        onChange={(e: any) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFileArquivos(file);
                            const reader = new FileReader();
                            reader.onload = (e) => {
                              setFileDataURL(e.target?.result as string);
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                        className="campanha-imagem-input"
                      />
                      <IonButton
                        fill="outline"
                        type="button"
                        onClick={() => imagemInputRef.current?.click()}
                      >
                        <IonIcon slot="start" icon={imageOutline} />
                        Selecionar imagem
                      </IonButton>
                      <IonNote className="campanha-imagem-nome">
                        {fileArquivos?.name || nomeImagem || "Nenhuma imagem selecionada"}
                      </IonNote>
                      {/*
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e: any) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFileArquivos(file);
                            const reader = new FileReader();
                            reader.onload = (e) => {
                              setFileDataURL(e.target?.result as string);
                            };
                            reader.readAsDataURL(file);
                          }
                        }}
                        style={{ marginBottom: '10px' }}
                      />
                      */}
                      {fileDataURL && (
                        <div style={{ marginTop: '10px' }}>
                          <img
                            src={fileDataURL}
                            alt="Preview"
                            style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '5px' }}
                          />
                        </div>
                      )}
                      {(fileArquivos || urlImagem) && <IonButton fill="clear" onClick={removeCampaignImage}>Remover imagem</IonButton>}
                    </div>}

                    {/* <div className="campanha-variaveis">
                      <IonLabel>Variáveis disponíveis</IonLabel>
                      <div className="campanha-variaveis-botoes">
                        <IonButton
                          size="small"
                          fill="outline"
                          type="button"
                          onClick={() => inserirVariavelMensagem("@[nome-cliente]")}
                        >
                          <IonIcon slot="start" icon={personOutline} />
                          Inserir nome do cliente
                        </IonButton>
                        <IonButton
                          size="small"
                          fill="outline"
                          type="button"
                          onClick={() => inserirVariavelMensagem("@[link-pedido]")}
                        >
                          <IonIcon slot="start" icon={linkOutline} />
                          Inserir link do pedido
                        </IonButton>
                      </div>
                      <IonNote>@[nome-cliente] e @[link-pedido]</IonNote>
                    </div> */}

                    {presentation.freeTextMode && <><div className="campanha-modelos-mensagem">
                      <IonLabel>Escolha um modelo de mensagem</IonLabel>
                      <IonNote>
                        Selecione um modelo pronto. Você pode ajustar o texto antes de ativar a campanha.
                      </IonNote>

                      <div className="campanha-modelos-grid">
                        {modelosMensagemCampanha
                          .filter((modelo) => modelo.id !== "cupom_desconto" || cupomCampanha)
                          .map((modelo) => (
                            <button
                              key={modelo.id}
                              type="button"
                              className={`campanha-modelo-card ${modeloMensagemSelecionado === modelo.id ? "campanha-modelo-card-ativo" : ""}`}
                              onClick={() => aplicarModeloMensagem(modelo)}
                            >
                              <strong>{modelo.titulo}</strong>
                              <span>{modelo.descricao}</span>
                            </button>
                          ))}
                      </div>
                    </div>

                    {/* <IonLabel>Prévia da mensagem</IonLabel>
                    <IonTextarea
                      placeholder="Digite sua mensagem..."
                      value={mensagemEnviar}
                      onIonInput={(e: any) => setMensagemEnviar(e.target.value)}
                      rows={6}
                      style={{ border: '1px solid #e0e0e0', borderRadius: '5px', padding: '10px' }}
                      maxlength={300}
                    />

                    <div style={{ textAlign: 'right', fontSize: '12px', color: '#666', marginTop: '5px' }}>
                      {mensagemEnviar.length}/300 caracteres
                    </div> */}

                    <div className="campanha-mensagem-previa">
                      <IonLabel>Prévia da mensagem</IonLabel>
                      <div className="campanha-mensagem-previa-conteudo">
                        {gerarPreviasMensagem(mensagemEnviar).length > 0 ? (
                          gerarPreviasMensagem(mensagemEnviar).map((previa, indice) => (
                            <div className="campanha-mensagem-previa-item" key={`previa-${indice}`}>
                              <strong>Variação {indice + 1}</strong>
                              <span>{previa}</span>
                            </div>
                          ))
                        ) : (
                          "A prévia aparecerá aqui conforme você escolher um modelo."
                        )}
                      </div>
                    </div>
                    </>}
                  </IonCardContent>
                </IonCard>
              )}
            </IonGrid>
          </IonContent>

          <IonFooter className="ion-no-border">
            <IonToolbar>
              <IonGrid>
                <IonRow>
                  {etapaAtual > 1 && (
                    <IonCol>
                      <IonButton fill="outline" onClick={voltarEtapa} expand="block">
                        VOLTAR
                      </IonButton>
                    </IonCol>
                  )}
                  <IonCol>
                    {etapaAtual < 5 ? (
                      <IonButton onClick={avancarEtapa} expand="block">
                        PRÓXIMO
                      </IonButton>
                    ) : (
                      <>
                        {presentation.templateMode && <IonButton fill="outline" disabled={showLoading || !campaignContext?.canEdit}
                          onClick={() => salvarCampanha(true)} expand="block">SALVAR CONFIGURAÇÃO PAUSADA</IonButton>}
                        <IonButton disabled={showLoading || !campaignContext || (statusCampanha === 'ativo' && !!presentation.activationError)}
                          onClick={() => salvarCampanha()} expand="block">
                          {statusCampanha === 'pausado' ? 'SALVAR PAUSADA' : index === '' ? 'ATIVAR' : 'SALVAR E MANTER ATIVA'}
                        </IonButton>
                      </>
                    )}
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonToolbar>
          </IonFooter>
        </IonModal>

        <IonToast
          isOpen={showToast}
          position="middle"
          onDidDismiss={() => setShowToast(false)}
          message={textToast}
          duration={3000}
        />

        <IonLoading
          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          spinner="circles"
        />
      </IonContent>

      {/* Modal de Prévia */}
      <IonModal isOpen={showModalPrevia} onDidDismiss={() => setShowModalPrevia(false)}>
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonButtons slot="start">
              <IonIcon slot="icon-only" icon={arrowBack} onClick={() => setShowModalPrevia(false)} />
            </IonButtons>
            <IonTitle>Prévia da campanha</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          {previaDados ? (
            <IonList>
              <IonItem lines="full">
                <IonLabel>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <IonChip color="primary">
                      Público:{'\u00A0'}<b>{getDescricaoPublico(previaDados?.campanha) || ''}</b>
                    </IonChip>
                    <IonChip color="primary">
                      Período:{'\u00A0'}<b>{previaDados?.campanha?.periodo} dias</b>
                    </IonChip>
                    <IonChip color="tertiary">
                      Total:{'\u00A0'}<b>{previaDados?.total ?? previaDados?.Items?.length ?? 0} cliente(s)</b>
                    </IonChip>

                  </div>

                </IonLabel>
              </IonItem>

              {(previaDados?.Items || []).map((cli: any, idx: number) => (
                <IonItem key={idx} lines="full">
                  <IonLabel>
                    <div style={{ fontWeight: 'bold' }}>{cli?.nome || 'Cliente'}</div>
                    <div style={{ fontSize: '12px', color: '#666' }}>{cli?.telefone}</div>
                  </IonLabel>
                </IonItem>)
              )}
            </IonList>
          ) : (
            <div style={{ padding: 16 }}>Carregando...</div>
          )}
        </IonContent>
      </IonModal>

      {/* Popover de ações */}
      <IonPopover
        isOpen={showPopoverGrid}
        event={popoverEventGrid}
        onDidDismiss={() => setShowPopoverGrid(false)}
      >
        <IonList>
          {getButtonsGridCampanha(itemSelecionado || {}).map((button: any, btnIndex: number) => (
            <IonItem key={btnIndex} lines="none" disabled={button.disabled} button onClick={() => {
              if (button.handler) button.handler();
              setShowPopoverGrid(false);
            }}>
              <IonIcon icon={button.icon} slot="start" />
              <IonLabel>{button.text}</IonLabel>
            </IonItem>
          ))}
        </IonList>
      </IonPopover>
    </IonPage>
  );
};

export default ProgramarMensagensClientes;
